import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT, MINERALS } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t hairline-gold bg-navy-950">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src="/assets/tg-icon.png" alt="Tuskers Grey monogram" className="h-14 w-auto" />
            <p className="mt-6 font-serif text-2xl leading-snug text-slate-100">
              TUSKERS <span className="text-gold">GREY</span>
              <span className="mt-1 block text-xs uppercase tracking-[0.42em] text-gold/80 font-sans">
                Investments
              </span>
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              Mining and mine product brokerage from the heart of the Great Dyke —
              connecting Midlands minerals to global markets with verified assays and
              export-ready logistics.
            </p>
            <a
              href={CONTACT.holdings}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-holdings-link"
              className="mt-6 inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.25em] text-slate-500 transition-colors hover:text-gold"
            >
              A Tuskers Grey company <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.3em] text-gold">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[["Home", "/"], ["About", "/about"], ["Minerals", "/products"], ["Services", "/services"], ["Contact", "/contact"]].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-slate-400 transition-colors hover:text-gold"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.3em] text-gold">Minerals</p>
            <ul className="mt-5 space-y-3 text-sm">
              {MINERALS.map((m) => (
                <li key={m.id}>
                  <Link
                    to="/products"
                    data-testid={`footer-mineral-${m.id}`}
                    className="text-slate-400 transition-colors hover:text-gold"
                  >
                    {m.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-gold">Contact</p>
            <ul className="mt-5 space-y-4 text-sm">
              {CONTACT.phones.map((p) => (
                <li key={p.id}>
                  <a
                    href={p.tel}
                    data-testid={`footer-phone-${p.id}`}
                    className="flex items-center gap-3 text-slate-300 transition-colors hover:text-gold"
                  >
                    <Phone className="h-4 w-4 text-gold/70" /> {p.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-slate-300 transition-colors hover:text-gold"
                >
                  <Mail className="h-4 w-4 text-gold/70" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400" data-testid="footer-location">
                <MapPin className="h-4 w-4 text-gold/70" /> {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/5 pt-8 text-xs uppercase tracking-[0.25em] text-slate-600 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© 2026 Tuskers Grey Investments</p>
          <p>Mining · Broking · Delivering</p>
        </div>
      </div>
    </footer>
  );
}
